import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  Output,
  ViewChild
} from '@angular/core';

import {
  IOverbookedDotsClickData,
  SharedConfigValues,
  SharedConstants
} from '@app/eds';

@Component({
  selector: 'app-dots',
  templateUrl: './dots.component.html',
  styleUrls: ['./dots.component.scss']
})
export class DotsComponent {
  // Unique identifier for the component
  @Input() dotId!: number;

  // Total number of dots that has to be shown
  @Input() dotsCount: number = SharedConfigValues.TOTAL_DOTS_COUNT;

  // Event emitter when dots are clicked on.
  @Output() dotsClickEvent: EventEmitter<IOverbookedDotsClickData> =
    new EventEmitter<IOverbookedDotsClickData>();

  // Element reference for dot container for getting its position
  @ViewChild('dotContainer') dotContainerRef!: ElementRef;

  /**
   * Creates the range/array based on the total dots count
   * so that template could loop through and show appropriate
   * number of dots.
   *
   * @returns {number[]}
   */
  createRange = () => Array.from({ length: this.dotsCount }).fill(SharedConstants.ZERO);

  /**
   * Emits event when the dots are clicked upon.
   *
   * @param {MouseEvent} event
   */
  onDotsClick = (event: MouseEvent) => {
    const eventData: IOverbookedDotsClickData = {
      dotId: this.dotId,
      dotContainerRect: this.dotContainerRef.nativeElement.getBoundingClientRect(),
      event: event
    };
    this.dotsClickEvent.emit(eventData);
  };
}
